import React, { useContext, useEffect, forwardRef } from 'react';
import { NAMESPACE, useLang } from '@/hooks/use-lang';
import Link from 'next/link';

interface IProps {
  orderNumber: string;
  catalogNumber: string;
  poNumber?: string;
  webOrderNumber: string;
  id?: string;
}
export const Cancel = forwardRef<HTMLInputElement, IProps>(function Cancel(props, ref) {
  const { orderNumber, catalogNumber, poNumber, webOrderNumber, id } = props;
  const { t } = useLang(NAMESPACE.cancelOrder);
  return (
    <Link
      prefetch
      href={{
        pathname: '/cancel-order',
        query: {
          orderNumber: orderNumber,
          poNumber: poNumber,
          sku: catalogNumber,
          webOrderNumber: webOrderNumber,
          id: id,
        },
      }}
    >
      <div className="text-[black] print:hidden border border-solid border-gray-300 w-max px-4 py-1 rounded-2xl mr-4 font-normal text-xs cursor-pointer">
        {t('cancel.btn')}
      </div>
    </Link>
  );
});
